import "./theme.css";
import type { Brand } from "../types";
import { meta } from "./meta";
import { fluent } from "./fluent";
import { SplashMark } from "./SplashMark";
import logo from "./assets/logo.svg";
import avatar from "./assets/avatar.svg";
import clearChatIcon from "./assets/clear-chat.svg";
import About from "./pages/About";
import TermsOfUse from "./pages/TermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SmsTerms from "./pages/SmsTerms";

export const brand: Brand = {
    ...meta,
    logo,
    avatar,
    clearChatIcon,
    tagline: "Everything on base, one question away.",
    exampleQuestions: [
        "What are my childcare options as a new parent?",
        "What resources does the Military & Family Readiness Center provide?",
        "Can you give me some historical background on the base?",
        "Is there a fitness center on base?"
    ],
    domainNoun: { singular: "base", plural: "bases" },
    domainUrlParam: "base",
    tour: {
        welcomeParagraphs: [
            "Base Buddy is your AI-powered assistant for life on base. Get instant answers about services, housing, events, and more.",
            "Base Buddy curates its information from official base resources and documentation. It is not designed to respond to queries outside of the scope of this dataset."
        ],
        clearChat:
            "Click the new message icon to clear the chat. Base Buddy uses the context of your current chat to provide better responses. It is recommended to clear the chat when asking a question on a new or unrelated topic."
    },
    splash: {
        Mark: SplashMark,
        background: "linear-gradient(160deg, #0d1117 0%, #161d27 50%, #1a2332 100%)",
        accent: "#4a7aff",
        fontFamily: "Poppins, sans-serif",
        phrases: ["Connecting to Base Buddy...", "Loading resources...", "Preparing your assistant...", "Almost ready..."]
    },
    colors: {
        navMenuIcon: "#b3cbff",
        domainPickerText: "#1a2535",
        installPromptBackground: "#1a2233",
        installPromptAccent: "#4a7aff"
    },
    features: { installApp: true, smsTerms: true },
    about: { href: "https://basebuddy.ai/", Page: About },
    pages: { TermsOfUse, PrivacyPolicy, SmsTerms },
    fluent
};
